import React from "react";
import Field from "src/components/common/FormComponents/Field";
import { FieldNameProps } from "src/components/Feedback/components/types";

const FieldName: React.FC<FieldNameProps> = ({ errors, register }) => {
  return (
    <Field
      type="name"
      error={errors.name?.message}
      register={register("name", {
        required: "Введите имя",
        minLength: { value: 2, message: "Слишком короткое имя" },
        maxLength: { value: 12, message: "Слишком длинное имя" },
      })}
      fullWidth
      placeholder="Ваше имя"
    />
  );
};

export default FieldName;
